"use strict";
exports.__esModule = true;
exports.HELP_MENU_CONTENT = void 0;
exports.HELP_MENU_CONTENT = {
    TITLE: 'Need some help?',
    HELP_CENTER: 'Visit our help center',
    RESTART_SIGNUP: 'Restart signup',
    RE_APPLY: 'Re-apply',
    NEW_PHONE_NUMBER: 'I have a new phone number',
    LOG_OUT: 'Log out',
    PRODUCT_SELECTION: 'Explore all Flex services'
};
